module.exports = new __parcel__URL__("computerwelt.ff1a5015.jpg").toString();